import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  recents = new BehaviorSubject<any>([]);
  recentsSites = new BehaviorSubject<any>([]);

  constructor() { }


}